import Contactus from "../Components/ContactUs/Contactus";
const Contact = () => {
    return (
        <>
            <Contactus />
        </>
    )
}
export default Contact;